import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import "./styles.css";
// logo import — tu peux remplacer par "/mnt/data/fe99f16e-3b98-463f-aadb-685c2a1d4166.png" si besoin
import logo from "../../assets/logo.png";
import logoutIcon from "../../assets/logout.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faBell, faXmark } from "@fortawesome/free-solid-svg-icons";

import { logout } from "../../redux/actions/authActions";
import { setActiveSection } from "../../redux/actions/dashboardActions";
import { fetchActiveSubscription } from "../../redux/actions/subscriptionOfferAction";

import AccueilDashboard from "../../components/AccueilDashboard";
import SubscriptionOffersPrestataire from "../../components/SubscriptionOffersPrestataire";
import ActiveSubscriptionCard from "../../components/ActiveSubscriptionCard";
import MesProjetsDashboard from "../../components/MesProjetsDashboard";
import MesAppelsOffresDashboard from "../../components/MesAppelsOffresDashboard";
import NotificationsDashboard from "../../components/NotificationsDashboard";
import ProfilPrestataire from "../../components/ProfilPrestataire";
import StepDocuments from "../../components/StepDocuments";
import { fetchProfilPrestataire } from "../../redux/actions/profilActions";
import Factures from "../../components/Factures";
import SearchProjets from "../../components/SearchProjets";

const PrestataireDashboard = () => {
    const { user: authUser, token } = useSelector((state) => state.auth);
    const { prestataire } = useSelector((state) => state.profil);
    const { activeSection } = useSelector((state) => state.dashboard);
    const { activeSubscription } = useSelector((state) => state.subscriptionOffer);
    const notifications = useSelector((state) => state.notification?.list || []); // non-lues si ton API renvoie que non-lues
    const unreadCount = notifications.length;

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [menuOpen, setMenuOpen] = useState(false);

    useEffect(() => {
        if (!authUser) navigate("/espace-prestataire");
    }, [authUser, navigate]);

    useEffect(() => {
        if (token) dispatch(fetchActiveSubscription(token));
    }, [dispatch, token]);

    
    const handleLogout = () => {
        dispatch(logout());
        navigate("/espace-prestataire");
    };

    useEffect(() => {
        if (activeSection === "")
            dispatch(setActiveSection("projets"));
    }, [activeSection, dispatch]);

    // ❗useEffect aussi doit être au-dessus
    useEffect(() => {
        if (!authUser || !token) {
            navigate("/");
        } else {
            dispatch(fetchProfilPrestataire(token));
        }
    }, [authUser, token, navigate, dispatch]);

    // 🔥 Seulement maintenant : on peut retourner null
    if (!prestataire) return null;

    const openNotifications = () => {
        dispatch(setActiveSection("notifications"));
        setMenuOpen(false);
    };

    const sections = {
        // accueil: <AccueilDashboard />,
        offres: <SubscriptionOffersPrestataire />,
        offreActive: <ActiveSubscriptionCard activeSubscription={activeSubscription} />,
        projets: <MesProjetsDashboard />,
        notifications: <NotificationsDashboard />,
        appelOffre: <MesAppelsOffresDashboard />,
        profil: <ProfilPrestataire />,
        validerProfil: <StepDocuments />,
        factures: <Factures/>,
    };

    return (
        <main className="prestataire-dashboard">
            <nav className={`prestataire-menu ${menuOpen ? "open" : ""}`}>
                {/* MOBILE HEADER (logo centered, icons top-right) */}
                <div className="mobile-header">
                    <img src={logo} alt="Logo Intereseaux" className="logo-mobile" />

                    <div className="mobile-top-icons">
                        <button
                            className="icon-btn notif-btn-mobile"
                            onClick={openNotifications}
                            aria-label="Notifications"
                        >
                            <FontAwesomeIcon icon={faBell} shake={unreadCount > 0} />
                            {unreadCount > 0 && <span className="notif-badge-mobile">{unreadCount}</span>}
                        </button>

                        <button
                            className="icon-btn hamburger-btn"
                            onClick={() => setMenuOpen((s) => !s)}
                            aria-expanded={menuOpen}
                            aria-label="Ouvrir le menu"
                        >
                            <FontAwesomeIcon icon={menuOpen ? faXmark : faBars} />
                        </button>
                    </div>
                </div>

                {/* DESKTOP LOGO */}
                <div className="logo-desktop">
                    <a href="/espace-prestataire">
                        <img src={logo} alt="Logo Intereseaux" className="logo-dashboard-img" />
                    </a>
                </div>

                {/* DESKTOP BELL (centered under logo) */}
                <div className="notif-desktop-wrapper">
                    <button className="icon-btn notif-btn-desktop" onClick={openNotifications} aria-label="Notifications">
                        <FontAwesomeIcon icon={faBell} shake={unreadCount > 0} />
                        {unreadCount > 0 && <span className="notif-badge-desktop">{unreadCount}</span>}
                    </button>
                </div>

                <div className="credits-info">
                    💙 Crédits Likes : <strong>{authUser?.profilPrestataire?.creditLikes ?? 0}</strong>
                </div>

                {/* MENU ITEMS */}
                <ul className="menu-items">

                    {activeSubscription && (
                        <li className={activeSection === "offreActive" ? "active" : ""} onClick={() => { dispatch(setActiveSection("offreActive")); setMenuOpen(false); }}>
                            MON OFFRE ACTUELLE
                        </li>
                    )}

                    <li className={activeSection === "offres" ? "active" : ""} onClick={() => { dispatch(setActiveSection("offres")); setMenuOpen(false); }}>
                        SOUSCRIRE A UNE OFFRE
                    </li>

                    <li className={activeSection === "projets" ? "active" : ""} onClick={() => { dispatch(setActiveSection("projets")); setMenuOpen(false); }}>
                        CHERCHER DES PROJETS
                    </li>

                    <li className={activeSection === "appelOffre" ? "active" : ""} onClick={() => { dispatch(setActiveSection("appelOffre")); setMenuOpen(false); }}>
                        CHERCHER DES APPELS D'OFFRES
                    </li>

                    <li className={activeSection === "factures" ? "active" : ""} onClick={() => { dispatch(setActiveSection("factures")); setMenuOpen(false); }}>
                        MES FACTURES
                    </li>
                    <li className={activeSection === "profil" ? "active" : ""} onClick={() => { dispatch(setActiveSection("profil")); setMenuOpen(false); }}>
                        MON PROFIL
                    </li>
                    {
                        (prestataire.validationProfil === "not_verified" || prestataire.validationProfil === "refused") && (
                            <li className={activeSection === "validerProfil" ? "active" : ""} onClick={() => { dispatch(setActiveSection("validerProfil")); setMenuOpen(false); }}>
                                VERIFIER MON PROFIL
                            </li>
                        )
                    }


                    <li>
                        <button className="logout-btn" onClick={handleLogout} aria-label="Se déconnecter">
                            <img src={logoutIcon} alt="Logout" />
                        </button>
                    </li>
                </ul>
            </nav>

            <section className="prestataire-content" onClick={() => menuOpen && setMenuOpen(false)}>
                {sections[activeSection]}
            </section>
        </main>
    );
};

export default PrestataireDashboard;
